<template>
  <div>
    <div class="flex -mx-4">
      <div class="w-1/3 px-4 space-y-8">
        <BaseFormGroup>
          <BaseFormLabel> Date preset </BaseFormLabel>
          <div>
            <BaseFormSelect :options="datePresetOptions" v-model="query.date_preset" />
          </div>
        </BaseFormGroup>

        <BaseFormGroup>
          <BaseFormLabel> Aggregate period </BaseFormLabel>
          <div>
            <BaseFormSelect :options="periodOptions" v-model="query.period" />
          </div>
        </BaseFormGroup>

        <BaseFormGroup>
          <BaseFormLabel> Metrics </BaseFormLabel>
          <div>
            <div
              class="bg-white shadow overflow-hidden sm:rounded-md mt-2 divide-y divide-gray-200"
            >
              <ul
                class="divide-y divide-gray-200"
                v-for="(category, idx) in metricGroupedOptions"
                :key="idx"
              >
                <li>
                  <div class="px-4 py-3" @click="toggleMetricGroup(category)">
                    <p class="font-medium">
                      {{ category.label }}
                    </p>
                  </div>
                </li>
                <li v-show="metricTab === category.label">
                  <ul class="divide-y divide-gray-200">
                    <li v-for="metric in category.metrics" :key="metric.value">
                      <label
                        class="group flex px-4 py-3"
                        :class="isMetricChecked(metric) && 'bg-blue-50'"
                      >
                        <input
                          type="checkbox"
                          class="hidden"
                          :value="metric.value"
                          v-model="query.metric"
                        />
                        <div class="flex-1">
                          <p
                            class="text-sm font-medium"
                            :class="isMetricChecked(metric) && 'text-blue-900'"
                          >
                            {{ metric.label }}
                          </p>
                          <p class="text-sm" :class="isMetricChecked(metric) && 'text-blue-500'">
                            {{ metric.description }}
                          </p>
                        </div>
                        <div v-show="isMetricChecked(metric)" class="flex-none flex items-center">
                          <span class="text-blue-600">
                            <svg
                              class="h-5 w-5"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                              fill="currentColor"
                              aria-hidden="true"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                clip-rule="evenodd"
                              />
                            </svg>
                          </span>
                        </div>
                      </label>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </BaseFormGroup>
        <BaseVeeForm :action="submitForm">
          <div class="flex space-x-2">
            <BaseButton primary :disabled="this.loading"> Submit </BaseButton>
            <BaseButton type="button" ghost :disabled="this.loading" @click="clearQuery">
              Clear
            </BaseButton>
          </div>
        </BaseVeeForm>
      </div>
      <div class="w-2/3 px-4">
        <div class="bg-white shadow overflow-hidden sm:rounded-md mt-2">
          <ul class="space-y-8">
            <li class="space-y-4 px-4 py-3">
              <h4>Request params</h4>
              <pre v-text="query" />
            </li>
            <li class="space-y-4 px-4 py-3">
              <h4>Result</h4>
              <pre v-text="result" class="whitespace-pre-wrap" />
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { facebookPageInsightsClient } from '@/api/clients/admin';
import * as queryParams from '@/utils/facebook-page-insights-query-params';

export default {
  props: {
    pageId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      datePresetOptions: [...queryParams.datePresetOptions],
      periodOptions: [...queryParams.periodOptions],
      metricGroupedOptions: [
        ...queryParams.metricsByCategory.map((item) => ({
          ...item,
          metrics: item.metrics.map((metric) => queryParams.metrics[metric]),
        })),
      ],

      query: {
        date_preset: null,
        period: null,
        metric: [],
      },

      metricTab: null,

      loading: false,
      result: null,
      rejectReason: null,
    };
  },
  methods: {
    isMetricChecked(metric) {
      return this.query.metric.indexOf(metric.value) > -1;
    },
    toggleMetricGroup(group) {
      if (this.metricTab === group.label) {
        this.metricTab = null;
        return;
      }

      this.metricTab = group.label;
    },
    async submitForm() {
      this.rejectReason = null;
      this.result = null;
      this.loading = true;
      try {
        const response = await facebookPageInsightsClient.read(this.pageId, this.query);
        this.result = JSON.stringify(response.data.data, null, 2);
      } catch (error) {
        this.rejectReason = error.message;
      } finally {
        this.loading = false;
      }
    },
    clearQuery() {
      this.query.period = null;
      this.query.date_preset = null;
      this.query.metric = [];
      this.metricTab = null;
    },
  },
};
</script>
